import { useState } from "react";
import { Link } from "@/components/common/Link";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from "@/components/ui/dropdown-menu";
import { Sheet, SheetContent, SheetHeader, SheetTitle, SheetTrigger } from "@/components/ui/sheet";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
import { WvcLogo } from '@/integrations/wordpress/WvcLogo';
import { ChevronDown, ChevronUp } from "lucide-react";
function NavMenuContent() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <div className="hidden lg:flex items-center gap-8 animate-pulse h-10 w-64 bg-white/10 rounded-md" />;
  }
  return <nav className="hidden lg:flex items-center" style={{
    backgroundPosition: '0% 0%',
    backgroundRepeat: 'repeat',
    color: 'rgb(0, 0, 0)',
    fontFamily: 'Inter, sans-serif',
    alignItems: 'center',
    animation: 'none 0s ease 0s 1 normal none running',
    gap: '32px',
    columnGap: '32px',
    rowGap: '32px'
  }}>
      {menuItems.map((item, i) => {
      const hasChildren = item.children && item.children.length > 0;
      if (hasChildren) {
        return <DropdownMenu key={item.id}>
              <DropdownMenuTrigger asChild>
                <button className="services-btn" data-index={i}>
                  {item.label}
                  <span dangerouslySetInnerHTML={{
                __html: `<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="m6 9 6 6 6-6"></path></svg>`
              }} />
                </button>
              </DropdownMenuTrigger>
              <DropdownMenuContent align="start" style={{
            fontFamily: 'Inter, sans-serif'
          }} className="rounded-md">
                {item.children?.map((child, ci) => <DropdownMenuItem key={child.id} asChild data-index={ci}>
                    <Link to={child.href || "#"}>{child.label}</Link>
                  </DropdownMenuItem>)}
              </DropdownMenuContent>
            </DropdownMenu>;
      }
      return <Link key={item.id} to={item.href || "#"} className="nav-link" data-index={i}>
            {item.label}
          </Link>;
    })}

      <Link to="#" style={{
      display: 'inline-flex',
      alignItems: 'center',
      justifyContent: 'center',
      width: '135px',
      height: '38px',
      backgroundColor: '#419ee7',
      color: '#F9F9F6',
      fontFamily: 'Inter, sans-serif',
      fontSize: '14px',
      fontWeight: 600,
      border: '1px solid #3586c5',
      textDecoration: 'none',
      cursor: 'pointer',
      transition: 'background-color 0.2s ease',
      whiteSpace: 'nowrap',
      flexShrink: 0
    }} className="rounded-md" onMouseEnter={e => e.currentTarget.style.backgroundColor = '#3586c5'} onMouseLeave={e => e.currentTarget.style.backgroundColor = '#419ee7'}>
        Get a Quote
      </Link>
    </nav>;
}
function MobileMenuContent() {
  const {
    menuItems
  } = useMenu();
  const [expandedItems, setExpandedItems] = useState<Record<string, boolean>>({});
  const toggleItem = (id: string) => {
    setExpandedItems(prev => ({
      ...prev,
      [id]: !prev[id]
    }));
  };
  return <div className="flex flex-col gap-4 mt-8 p-6">
      {menuItems.map((item, i) => {
      const hasChildren = item.children && item.children.length > 0;
      const isExpanded = expandedItems[item.id];
      if (hasChildren) {
        return <div key={item.id} className="flex flex-col gap-2" data-index={i}>
              <button onClick={() => toggleItem(item.id)} style={{
            color: '#fff',
            fontFamily: 'Inter, sans-serif',
            fontSize: '16px',
            textDecoration: 'none'
          }} className="px-4 py-3 rounded-lg font-medium transition-colors duration-200 hover:bg-white/10 hover:opacity-90 flex items-center justify-between min-h-[44px] w-full text-left">
                {item.label}
                {isExpanded ? <ChevronUp className="size-4" /> : <ChevronDown className="size-4" />}
              </button>
              {isExpanded && <div className="flex flex-col gap-2 ml-4">
                  {item.children?.map((child, ci) => <Link key={child.id} to={child.href || "#"} style={{
              color: 'rgba(255, 255, 255, 0.8)',
              fontFamily: 'Inter, sans-serif',
              fontSize: '14px',
              textDecoration: 'none'
            }} className="px-4 py-2 rounded-lg transition-colors duration-200 hover:bg-white/5 flex items-center min-h-[40px]" data-index={ci}>
                      {child.label}
                    </Link>)}
                </div>}
            </div>;
      }
      return <Link key={item.id} to={item.href || "#"} style={{
        color: '#fff',
        fontFamily: 'Inter, sans-serif',
        fontSize: '16px',
        textDecoration: 'none'
      }} className="px-4 py-3 rounded-lg font-medium transition-colors duration-200 hover:bg-white/10 hover:opacity-90 flex items-center min-h-[44px]" data-index={i}>
          {item.label}
        </Link>;
    })}
      <Link to="#" style={{
      display: 'inline-flex',
      alignItems: 'center',
      justifyContent: 'center',
      backgroundColor: '#419ee7',
      color: '#F9F9F6',
      fontFamily: 'Inter, sans-serif',
      fontSize: '16px',
      fontWeight: 700,
      border: '1px solid #3586c5',
      textDecoration: 'none',
      cursor: 'pointer'
    }} className="rounded-lg px-6 py-4 mt-4 transition-colors duration-200 hover:bg-[#3586c5] min-h-[48px]">
        Get a Quote
      </Link>
    </div>;
}
export default function Header() {
  return <header id="header" className="fixed sticky top-0 z-50 w-full" style={{
    height: '78px',
    backgroundColor: 'black',
    position: 'fixed',
    top: 0
  }}>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;600;700&family=Playfair+Display:wght@700&display=swap');
        @keyframes spin { 100% { transform: rotate(360deg); } }
        @keyframes pulse { 50% { opacity: 0.5; } }
        @keyframes enter {
          0% { opacity: var(--tw-enter-opacity,1); transform: translate3d(var(--tw-enter-translate-x,0),var(--tw-enter-translate-y,0),0)scale3d(var(--tw-enter-scale,1),var(--tw-enter-scale,1),var(--tw-enter-scale,1))rotate(var(--tw-enter-rotate,0)); filter: blur(var(--tw-enter-blur,0)); }
        }
        @keyframes exit {
          100% { opacity: var(--tw-exit-opacity,1); transform: translate3d(var(--tw-exit-translate-x,0),var(--tw-exit-translate-y,0),0)scale3d(var(--tw-exit-scale,1),var(--tw-exit-scale,1),var(--tw-exit-scale,1))rotate(var(--tw-exit-rotate,0)); filter: blur(var(--tw-exit-blur,0)); }
        }
        @keyframes accordion-down {
          0% { height: 0px; }
          100% { height: var(--radix-accordion-content-height,auto); }
        }
        @keyframes accordion-up {
          0% { height: var(--radix-accordion-content-height,auto); }
          100% { height: 0px; }
        }
        .header-bg {
          background-color: black;
        }
        .nav-link {
          color: rgb(0, 0, 0);
          font-family: 'Inter', sans-serif;
          font-size: 14px;
          font-weight: 400;
          cursor: pointer;
          transition: opacity 0.15s ease;
          text-decoration: none;
          background: none;
          border: none;
          padding: 0;
        }
        .nav-link:hover { color: #419de5; }
        .services-btn {
          color: rgb(0, 0, 0);
          font-family: 'Inter', sans-serif;
          font-size: 14px;
          font-weight: 400;
          cursor: pointer;
          transition: opacity 0.15s ease;
          background: none;
          border: none;
          padding: 0;
          display: flex;
          align-items: center;
          gap: 4px;
        }
        .services-btn:hover { color: #419de5; }
      `}</style>

      <div className="header-bg w-full h-full" style={{
      position: 'absolute',
      inset: 0,
      zIndex: 0
    }} />

      <div className="relative w-full h-full flex items-center justify-between px-6 !bg-[rgba(255,255,255,1)] md:px-8" style={{
      zIndex: 1
    }}>
        <Link to="/" className="flex items-center">
          <WvcLogo className="h-[60px] w-auto" />
        </Link>

        <MenuProvider menu_id="16">
          <NavMenuContent />
        </MenuProvider>

        <Sheet>
          <SheetTrigger asChild className="flex flex-col justify-center items-center gap-1 !bg-[rgba(65,157,229,1)] lg:hidden">
            <button className="lg:hidden flex flex-col justify-center items-center gap-1" style={{
            background: 'none',
            border: 'none',
            cursor: 'pointer',
            padding: '4px'
          }} aria-label="Open menu">
              <span style={{
              display: 'block',
              width: '22px',
              height: '2px',
              backgroundColor: '#fff'
            }} />
              <span style={{
              display: 'block',
              width: '22px',
              height: '2px',
              backgroundColor: '#fff'
            }} />
              <span style={{
              display: 'block',
              width: '22px',
              height: '2px',
              backgroundColor: '#fff'
            }} />
            </button>
          </SheetTrigger>
          <SheetContent side="right" style={{
          backgroundColor: '#419ee7',
          borderLeft: '1px solid #3586c5'
        }}>
            <SheetHeader>
              <SheetTitle style={{
              color: '#fff',
              fontFamily: 'Inter, sans-serif',
              fontSize: '16px',
              fontWeight: 700
            }}>TM Plant</SheetTitle>
            </SheetHeader>
            <MenuProvider menu_id="16">
              <MobileMenuContent />
            </MenuProvider>
          </SheetContent>
        </Sheet>
      </div>
    </header>;
}